import { useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';

export function useDeleteOrgAvatar() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (tenantId: string) => organizationsService.deleteAvatar(tenantId),
    onSuccess: (_, tenantId) => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATIONS_KEYS.detail(tenantId, tenantId),
      });
    },
  });
}
